import template from './period-type-currency-select.jade';
import currency from '../../../../enums/currency';
import { trackSelectPeriodType } from './tracking';
import { getClientDeviceType } from '../../../../../../../shared/utils';
import { isAreaPartsEnabled } from '../../../../../../../shared/utils/offer';

const localPriceType = [{
  text: 'В месяц за м&sup2;',
  value: 'squareMeterMonthly',
  type: 'Rent',
}, {
  text: 'В год за м&sup2;',
  value: 'squareMeterAnnual',
  type: 'Rent',
}, {
  text: 'В месяц',
  value: 'allMonthly',
  type: 'Rent',
}, {
  text: 'За м&sup2;',
  value: 'squareMeter',
  type: 'Sale',
}, {
  text: 'За всё',
  value: 'all',
  type: 'Sale',
}];

export default angular
  .module('cian.addForm.helperPeriodTypeCurrencySelect', [])
  .directive('cianAfHelperPeriodTypeCurrencySelect', () => ({
    scope: {},
    transclude: true,
    bindToController: {
      ad: '=',
      form: '=',
      inputName: '@',
      inputModel: '=',
      currencyModel: '=?', // ожидаем объект со свойством currency
      currencyName: '@?',
      priceTypeModel: '=?', // ожидаем объект со свойством priceType
      priceTypeName: '@?',
      priceLimit: '@?',
      isDisabled: '=',
      isRequired: '@?',
      validationMessages: '=?',
      useMinPriceLimit: '@?',
      placeholder: '@?',
      allowZero: '@?',
      type: '=',
    },
    require: 'cianAfHelperPeriodTypeCurrencySelect',
    controller(deviceService, $scope, $rootScope) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      if (!this.ad.bargainTerms) {
        this.ad.bargainTerms = {};
      }

      const isOfferEditing = !!this.ad.id;
      const product = this.ad.id && {
        id: this.ad.id,
        offerType: 'offer',
        position: 1,
      };
      const siteType = getClientDeviceType();
      this.currencies = currency;
      this.priceTypes = localPriceType.filter(f => this.ad.category.includes(f.type));
      let currentValue;
      if (this.ad.id) {
        const { priceType, paymentPeriod } = this.ad.bargainTerms;
        if (priceType === 'all' && paymentPeriod === 'monthly') {
          currentValue = 'allMonthly';
        } else if (priceType === 'squareMeter' && paymentPeriod === 'monthly') {
          currentValue = 'squareMeterMonthly';
        } else if (priceType === 'squareMeter' && paymentPeriod === 'annual') {
          currentValue = 'squareMeterAnnual';
        } else if (priceType === 'squareMeter' && paymentPeriod === undefined) {
          currentValue = 'squareMeter';
        } else if (priceType === 'all' && paymentPeriod === undefined) {
          currentValue = 'all';
        }
      }
      this.defaultPriceType = currentValue || this.priceTypes[0].value;

      if (angular.isUndefined(this.currencyModel)) {
        this.currencyModel = this.ad.bargainTerms;
      }

      if (angular.isUndefined(this.priceTypeModel)) {
        this.priceTypeModel = {};
      }

      if (angular.isUndefined(this.currencyName)) {
        this.currencyName = 'bargainTerms.currency';
      }

      if (angular.isUndefined(this.priceTypeName)) {
        this.priceTypeName = '';
      }

      let actionLabel = 'rent_in_parts_month';
      $rootScope.$on('addform.submit', () => {
        if (isAreaPartsEnabled(this.ad)) {
          trackSelectPeriodType(isOfferEditing, product, actionLabel, siteType);
        }
      });

      $scope.$watch(() => this.priceType, (priceType) => {
        if (angular.isUndefined(priceType)) return;

        if (priceType === 'allMonthly') {
          this.ad.bargainTerms.priceType = 'all';
          this.ad.bargainTerms.paymentPeriod = 'monthly';
          actionLabel = 'rent_in_parts_month';
        } else if (priceType === 'squareMeterMonthly') {
          this.ad.bargainTerms.priceType = 'squareMeter';
          this.ad.bargainTerms.paymentPeriod = 'monthly';
          actionLabel = 'rent_in_parts_month_m2';
        } else if (priceType === 'squareMeterAnnual') {
          this.ad.bargainTerms.priceType = 'squareMeter';
          this.ad.bargainTerms.paymentPeriod = 'annual';
          actionLabel = 'rent_in_parts_year_m2';
        } else if (priceType === 'squareMeter') {
          this.ad.bargainTerms.priceType = 'squareMeter';
          this.ad.bargainTerms.paymentPeriod = undefined;
        } else if (priceType === 'all') {
          this.ad.bargainTerms.priceType = 'all';
          this.ad.bargainTerms.paymentPeriod = undefined;
        }
      });
    },
    link(scope, element, attrs, ctrl) {
      ctrl.currencyModel.currency = ctrl.currencyModel.currency || ctrl.currencies[0].key;
      scope.$watch(() => ctrl.isDisabled, disabled => {
        ctrl.isDisabledParsed = angular.isDefined(disabled) ? String(disabled) === 'true' : false;
      });
    },
    controllerAs: 'priceCurrencySelect',
    template,
  }))
  .name;
